import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { FirmaObjekat } from './firma-objekat';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-firma-objekat',
  templateUrl: './firma-objekat.component.html'
})
export class FirmaObjekatComponent extends BaseModalContainer<FirmaObjekat> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<FirmaObjekat>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

}
